export default __webpack_public_path__ + "static/mountain-1-b082c493d721a89ef3aadf2fbe06b313.mp4";